<!-- eslint-disable vue/no-v-html -->
<template>
  <Card
    :title="homeTexts.title"
    class="autorization-card"
  >
    <template #before__body>
      <AutorizationHeader />
    </template>

    <template #body>
      <AutorizationBody />
    </template>

    <!-- <template #after__body>
      <div
        class="autorization-card__footer"
        v-html="homeTexts['autorization']?.['otherPortal']"
      />
    </template> -->
  </Card>
</template>

<script setup>
// #region VUE
import {computed} from 'vue';

import {useStore} from 'vuex';
// #endregion

// #region COMPONENTS COMPOSABLES
import AutorizationHeader from '@/components/autorization/AutorizationHeader.vue';
import AutorizationBody from '@/components/autorization/AutorizationBody.vue';
import Card from '@/components/card/Card.vue';
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const homeTexts = computed(() => store.getters['text/getSectionTexts']('home'));
// #endregion
</script>

<style lang="scss" scoped>
.autorization-card{

  &__footer{
    text-align: center;
    background: white;
    padding: .5rem;
    width: fit-content;
    margin: auto;
    margin-top: 2rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
}
</style>
